import { useState, FC } from 'react'
import {
    Nomenclature,
    useNomenclaturesAsyncAutocompleteOptions,
} from 'entities/nomenclatures/model'
import {
    Autocomplete,
    AutocompleteOption,
} from 'shared/components/Autocomplete'

export type NomenclaturesOption = AutocompleteOption<Nomenclature>

interface NomenclaturesAutocompleteProps {
    handleOnChangeEquipmentSelect: (
        option: AutocompleteOption<Nomenclature>,
    ) => void
    value?: AutocompleteOption<Nomenclature>
}

const buildAutocompleteOption = (
    nomenclature: Nomenclature,
): NomenclaturesOption => ({
    value: nomenclature.id.toString(),
    label: nomenclature.name,
    payload: nomenclature,
})

export const NomenclaturesAutocomplete: FC<NomenclaturesAutocompleteProps> = ({
    handleOnChangeEquipmentSelect,
    value,
}) => {
    const [searchString, setSearchString] = useState<string>()

    const { nomenclatures, fetchNextPage, isFetching } =
        useNomenclaturesAsyncAutocompleteOptions({
            search_param: searchString,
            size: 10,
        })

    const options: NomenclaturesOption[] =
        nomenclatures
            ?.filter(nomenclature => nomenclature.count >= 1)
            ?.map(buildAutocompleteOption) ?? []

    return (
        <Autocomplete
            options={options}
            onChange={handleOnChangeEquipmentSelect}
            value={value}
            placeholder='-'
            isLoading={isFetching}
            onInputChange={setSearchString}
            onLoadMore={fetchNextPage}
        />
    )
}
